import React from "react";
import { Container, Col, Row, Button } from "reactstrap";
import styles from "./OurPeople.module.scss";

const OurPeople = ({ headline, description, ctas }) => {
  return (
    <div>
      <Row className="mt-4 pt-4 mt-md-1 d-flex justify-content-center">
        <h2 className={styles.heading}>{headline}</h2>
      </Row>
      <Row className="mt-3 mt-md-1 d-flex justify-content-center">
        <p className={`${styles.textSection} mt4 text-center mx-4`}>
          {description}
        </p>
      </Row>
      <Container>
        <Row className=" mb-4 py-4">
          {/* {icons.map((icon) => {
            const Tag = icon.href ? "a" : "span";
            return (
              <Col key={icon.image} xs={6} md={2} className={`${styles.imgText} px-4 pt-2`}>
                {!React.isValidElement(icon) ? (
                  <Tag href={icon.href} target={icon.target} rel={icon.rel}>
                    <img src={icon.image} className={`${styles.iconImg} mb-4`} alt="" />
                    <p className="text-center text-md-left">{icon.text}</p>
                  </Tag>
                ) : (
                  icon
                )}
              </Col>
            )
          })} */}
          {ctas.map((cta) => {
            // const Tag = cta.href ? "a" : "span";

            return (
              <Col xs={6} md={3} className="pt-2 px-1">
                <a href={cta.href}>
                  <div className={`${styles.img} w-100 text-center`}>
                    {!React.isValidElement(cta.image)
                      ? (<img
                        width="100%"
                        className={styles.wrap}
                        src={cta.image?.url}
                        alt=""
                      />)
                      : cta.image}
                    <h5 className={styles.h55}>{cta.text}</h5>
                  </div>
                </a>
              </Col>
            )
          })}
        </Row>
      </Container>
    </div>
  );
};

export default OurPeople;
